import styled from 'styled-components';
import { useMapTokenPropsToCSS } from 'foundations-components/hooks/useMapTokenPropsToCSS';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledDots = styled.div.withConfig({
  displayName: "EPDragHandle__StyledDots"
})(({
  $textCssStyles,
  theme
}) => Object.assign({}, $textCssStyles, {
  fontSize: theme.typography['body-300'].fontSize,
  fontWeight: theme.typography['body-300'].fontWeight,
  lineHeight: 0.3,
  textAlign: 'center',
  whiteSpace: 'pre-wrap'
}));
const Dots = ({
  orientation
}) => {
  const dot = '·';
  const dimensions = orientation === 'horizontal' ? [6, 2] : [2, 6];
  return `${dot.repeat(dimensions[0])}\n`.repeat(dimensions[1]).trim();
};
const EPDragHandle = ({
  color = 'border-core-default',
  orientation = 'horizontal'
}) => {
  const textCssStyles = useMapTokenPropsToCSS({
    color
  });
  return (
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsx(StyledDots, {
      $textCssStyles: textCssStyles,
      children: /*#__PURE__*/_jsx(Dots, {
        orientation: orientation
      })
    })
  );
};
export default EPDragHandle;